import { ViewOrderHistoryChat } from '@ltvco/refresh-lib/payments';
import { Text } from '@ltvco/refresh-lib/theme';

import { StyledBillingSectionContainer } from './components';

export const BillingSection = () => {
  return (
    <StyledBillingSectionContainer>
      <Text variant="h3">Billing History</Text>
      <ViewOrderHistoryChat />
    </StyledBillingSectionContainer>
  );
};
